<template>
  <v-card class="item" height="100%" flat tile>
    <v-sheet class="rounded-circle item-img" color="#A8CF45" width="100%">
      <img class="d-block" :src="icon" :alt="title" width="100%" />
    </v-sheet>

    <div
      class="
        text-body-1 text-md-subtitle-1 text-center
        font-weight-bold
        mt-3 mt-md-5
        item-title
      "
    >
      {{ title }}
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  &-img {
    padding: 50px;

    @media screen and (max-width: 599.9px) {
      padding: 40px;
    }
  }

  &-title {
    color: #4f4f4f;
  }
}
</style>
